export interface UserPreferences {
  id: string
  user_id: string

  // Theme preferences
  theme_primary_color: string
  theme_accent_color: string

  // Layout preferences
  sidebar_collapsed: boolean
  navigation_order: string[]

  // Display preferences
  dashboard_layout: string
  table_density: 'compact' | 'normal' | 'comfortable'
  show_brand_logo: boolean
  brand_logo_size: 'small' | 'medium' | 'large'

  // Notification preferences
  toast_position: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'
  toast_duration: number

  // Timestamps
  created_at: string
  updated_at: string
}

export type UserPreferencesUpdate = Partial<Omit<UserPreferences, 'id' | 'user_id' | 'created_at' | 'updated_at'>>

export const DEFAULT_PREFERENCES: Omit<UserPreferences, 'id' | 'user_id' | 'created_at' | 'updated_at'> = {
  theme_primary_color: 'blue',
  theme_accent_color: 'orange',
  sidebar_collapsed: false,
  navigation_order: ['dashboard', 'customers', 'jobs', 'invoices', 'quotes', 'routing', 'messages', 'settings'],
  dashboard_layout: 'default',
  table_density: 'normal',
  show_brand_logo: true,
  brand_logo_size: 'medium',
  toast_position: 'top-right',
  toast_duration: 5000
}

export const THEME_COLORS = {
  primary: {
    blue: {
      name: 'Ocean Blue',
      value: 'blue',
      sample: '#3b82f6'
    },
    indigo: {
      name: 'Deep Indigo',
      value: 'indigo',
      sample: '#6366f1'
    },
    purple: {
      name: 'Royal Purple',
      value: 'purple',
      sample: '#9333ea'
    },
    emerald: {
      name: 'Forest Green',
      value: 'emerald',
      sample: '#10b981'
    },
    teal: {
      name: 'Ocean Teal',
      value: 'teal',
      sample: '#14b8a6'
    },
    slate: {
      name: 'Modern Slate',
      value: 'slate',
      sample: '#64748b'
    }
  },
  accent: {
    orange: {
      name: 'Warm Orange',
      value: 'orange',
      sample: '#f97316'
    },
    amber: {
      name: 'Golden Amber',
      value: 'amber',
      sample: '#f59e0b'
    },
    rose: {
      name: 'Elegant Rose',
      value: 'rose',
      sample: '#f43f5e'
    },
    pink: {
      name: 'Vibrant Pink',
      value: 'pink',
      sample: '#ec4899'
    },
    cyan: {
      name: 'Electric Cyan',
      value: 'cyan',
      sample: '#06b6d4'
    },
    lime: {
      name: 'Fresh Lime',
      value: 'lime',
      sample: '#84cc16'
    }
  }
}